import { render, staticRenderFns } from "./UserPagination.vue?vue&type=template&id=39a2d833"
import script from "./UserPagination.vue?vue&type=script&lang=ts"
export * from "./UserPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports